import React from 'react';

const TemplateHeader3 = ({ branding }) => {
  const logoUrl = 'https://trawtelcdn.s3.eu-north-1.amazonaws.com/smarttravelcrm/uploads/companies/efd32bd2-6639-42ed-9b1a-7e262da1be07/logos/efd32bd2-6639-42ed-9b1a-7e262da1be07.png';
  const navLinks = ['Home', 'Tours', 'About', 'Contact'];

  const styles = {
    // The dark background is a specific design choice for this header, so we keep it.
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '1rem 3rem',
      backgroundColor: '#1a1a1a', 
      fontFamily: 'Verdana, sans-serif'
    },
    logo: {
      height: '40px',
    },
    navContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '2rem',
    },
    nav: {
      display: 'flex',
      gap: '1.5rem',
    },
    navLink: {
      textDecoration: 'none',
      color: '#e0e0e0',
      fontSize: '1rem',
    },
    // The theme-specific button style is REMOVED from here.
  };

  return (
    <header style={styles.header}>
      <img src={logoUrl} alt="Company Logo" style={styles.logo} />
      <div style={styles.navContainer}>
        <nav style={styles.nav}>
          {navLinks.map(link => (
            <a key={link} style={styles.navLink}>{link}</a>
          ))}
        </nav>
        {/* --- CHANGE IS HERE --- */}
        <button className="btn btn-primary">Book Now</button>
      </div>
    </header>
  );
};

export default TemplateHeader3;